import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root")!;

// Landing pages have their own dark hero — skip the marketing skeleton overlay
// so React's hero paints immediately as the LCP element (huge LCP win on mobile).
const isLP = location.pathname.startsWith("/lp/");
if (isLP) {
  const skeleton = document.getElementById("app-skeleton");
  if (skeleton) skeleton.remove();
  root.classList.add("hydrated");
}

createRoot(root).render(<App />);

if (!isLP) {
  // Reveal app and dismiss skeleton — let React finish painting first
  setTimeout(() => {
    root.classList.add("hydrated");
    const skeleton = document.getElementById("app-skeleton");
    if (skeleton) {
      skeleton.classList.add("hide");
      skeleton.addEventListener("transitionend", () => skeleton.remove(), { once: true });
    }
  }, 0);
}
